import './styles.css';

// English UI fonts. Injected from script so they never block first paint (Google may be slow or blocked in Iran)
// and no inline handler is needed under the site's Content-Security-Policy. Persian fonts are bundled.
const fonts = document.createElement('link');
fonts.rel = 'stylesheet';
fonts.href = 'https://fonts.googleapis.com/css2?family=Cinzel:wght@500;700;900&family=Inter:wght@400;600;800&display=swap';
document.head.append(fonts);
import { Game } from './game/Game';
import { useCheapLighting } from './core/materials';
import { loadSave } from './game/Save';

const canvas = document.querySelector<HTMLCanvasElement>('#game-canvas');

if (!canvas) {
  throw new Error('Missing #game-canvas element.');
}

// Makes the game installable (public/sw.js). Not in dev, where a worker would only get in the way.
if (import.meta.env.PROD && 'serviceWorker' in navigator) void navigator.serviceWorker.register('/sw.js').catch(() => undefined);

useCheapLighting(loadSave().settings.graphicsMode === 'low'); // before any lit material is created
const game = new Game(canvas);
game.start();

if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    game.dispose();
  });
}
